module.exports = __webpack_public_path__ + "static/img/BD.bff9eee6.png";